const e = "增量", n = "减量", t = {
  increment: e,
  decrement: n
};
export {
  n as decrement,
  t as default,
  e as increment
};
